import React from 'react';

const CommentIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="-5.0 -10.0 100.0 135.0"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <g>
                <path d="m39.75 29.734h38.891c0.86328 0 1.5625-0.69922 1.5625-1.5625s-0.69922-1.5625-1.5625-1.5625h-38.891c-0.86328 0-1.5625 0.69922-1.5625 1.5625s0.69922 1.5625 1.5625 1.5625z"/>
                <path d="m21.359 29.734h8.9062c0.86328 0 1.5625-0.69922 1.5625-1.5625s-0.69922-1.5625-1.5625-1.5625h-8.9062c-0.86328 0-1.5625 0.69922-1.5625 1.5625s0.69922 1.5625 1.5625 1.5625z"/>
                <path d="m78.645 40.688h-57.289c-0.86328 0-1.5625 0.69922-1.5625 1.5625s0.69922 1.5625 1.5625 1.5625h57.293c0.86328 0 1.5625-0.69922 1.5625-1.5625s-0.69922-1.5625-1.5625-1.5625z"/>
                <path d="m60.418 54.766h-39.062c-0.86328 0-1.5625 0.69922-1.5625 1.5625s0.69922 1.5625 1.5625 1.5625h39.062c0.86328 0 1.5625-0.69922 1.5625-1.5625s-0.69922-1.5625-1.5625-1.5625z"/>
                <path d="m89.777 7.9141h-79.555c-3.9141 0-7.0977 3.1836-7.0977 7.0977v54.477c0 3.9141 3.1836 7.0977 7.0977 7.0977h8.0703v13.938c0 0.58984 0.33203 1.1289 0.85938 1.3945 0.22266 0.11328 0.46094 0.16797 0.70312 0.16797 0.32812 0 0.65625-0.10156 0.92969-0.30469l20.559-15.195h48.434c3.9141 0 7.0977-3.1836 7.0977-7.0977v-54.477c0-3.9141-3.1836-7.0977-7.0977-7.0977zm3.9727 61.574c0 2.1914-1.7812 3.9727-3.9727 3.9727h-48.949c-0.33594 0-0.66016 0.10937-0.92969 0.30469l-18.48 13.66v-12.402c0-0.86328-0.69922-1.5625-1.5625-1.5625h-9.6328c-2.1914 0-3.9727-1.7812-3.9727-3.9727v-54.477c0-2.1914 1.7812-3.9727 3.9727-3.9727h79.555c2.1914 0 3.9727 1.7812 3.9727 3.9727z"/>
            </g>
        </svg>
    );
};

const DeleteIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 90 90"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <polygon points="66.36 80.06 33.64 80.06 31.74 27.62 25.91 27.83 28.01 85.9 71.99 85.9 74.09 27.83 68.26 27.62 66.36 80.06"/>
            <path d="M42.71,71.6V36.21a2.92,2.92,0,0,0-5.84,0V71.6a2.92,2.92,0,0,0,5.84,0Z"/>
            <path d="M52.92,71.6V36.21a2.92,2.92,0,0,0-5.84,0V71.6a2.92,2.92,0,0,0,5.84,0Z"/>
            <path d="M63.13,71.6V36.21a2.92,2.92,0,0,0-5.84,0V71.6a2.92,2.92,0,0,0,5.84,0Z"/>
            <path d="M62.93,20V18.14a6.75,6.75,0,0,0-6.75-6.74H43.82a6.75,6.75,0,0,0-6.75,6.74V20H19.21v5.84H80.79V20Zm-20-1.87a.9.9,0,0,1,.91-.9H56.18a.9.9,0,0,1,.91.9V20H42.91Z"/>
        </svg>
    );
};

const EditIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <path d="M19.607,18.746c0,0.881-0.716,1.624-1.597,1.624H5.231c-0.881,0-1.597-0.743-1.597-1.624V5.967  c0-0.881,0.716-1.571,1.597-1.571h7.454V3.332H5.231c-1.468,0-2.662,1.168-2.662,2.636v12.778c0,1.468,1.194,2.688,2.662,2.688  h12.778c1.468,0,2.662-1.221,2.662-2.688v-7.428h-1.065V18.746z"/>
        <path d="M20.807,3.17c-0.804-0.805-2.207-0.805-3.012,0l-7.143,7.143c-0.068,0.068-0.117,0.154-0.14,0.247L9.76,13.571  c-0.045,0.181,0.008,0.373,0.14,0.506c0.101,0.101,0.237,0.156,0.376,0.156c0.043,0,0.086-0.005,0.129-0.016l3.012-0.753  c0.094-0.023,0.179-0.072,0.247-0.14l7.143-7.143c0.402-0.402,0.624-0.937,0.624-1.506S21.21,3.572,20.807,3.17z M13.016,12.467  l-2.008,0.502l0.502-2.008l5.909-5.909l1.506,1.506L13.016,12.467z M20.054,5.428l-0.376,0.376l-1.506-1.506l0.376-0.376  c0.402-0.402,1.104-0.402,1.506,0c0.201,0.201,0.312,0.468,0.312,0.753C20.366,4.96,20.255,5.227,20.054,5.428z"/>
    </svg>
    );
};

const ExpandIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <style type="text/css">
                {`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}
            </style>
            <g transform="translate(377.000000, 253.000000)">
                <path className="st0" d="M-362.8-235.5c0-1.8,1.5-3.3,3.3-3.3h16.3c1.8,0,3.3,1.5,3.3,3.3c0,1.8-1.5,3.3-3.3,3.3h-8.4   l17.2,17.2c1.3,1.3,1.3,3.3,0,4.6c-1.3,1.3-3.3,1.3-4.6,0l-17.2-17.2v8.4c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3V-235.5z    M-310.8-238.8h16.3c1.8,0,3.3,1.5,3.3,3.3v16.3c0,1.8-1.5,3.3-3.3,3.3s-3.3-1.5-3.3-3.3v-8.4l-17.2,17.2c-1.3,1.3-3.3,1.3-4.6,0   c-1.3-1.3-1.3-3.3,0-4.6l17.2-17.2h-8.4c-1.8,0-3.3-1.5-3.3-3.3C-314-237.3-312.5-238.8-310.8-238.8z M-334.5-195.6   c1.3,1.3,1.3,3.3,0,4.6l-17.2,17.2h8.4c1.8,0,3.3,1.5,3.3,3.3s-1.5,3.3-3.3,3.3h-16.3c-1.8,0-3.3-1.5-3.3-3.3v-16.3   c0-1.8,1.5-3.3,3.3-3.3c1.8,0,3.3,1.5,3.3,3.3v8.4l17.2-17.2C-337.8-196.8-335.7-196.8-334.5-195.6z M-319.6-195.6   c1.3-1.3,3.3-1.3,4.6,0l17.2,17.2v-8.4c0-1.8,1.5-3.3,3.3-3.3s3.3,1.5,3.3,3.3v16.3c0,1.8-1.5,3.3-3.3,3.3h-16.3   c-1.8,0-3.3-1.5-3.3-3.3s1.5-3.3,3.3-3.3h8.4l-17.2-17.2C-320.8-192.2-320.8-194.3-319.6-195.6z"/>
            </g>
        </svg>
    );
};

const ProfileIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <style type="text/css">
                {`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}
            </style>
            <g>
                <path className="st0" d="M32,14c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12s12-5.4,12-12C44,19.4,38.6,14,32,14z M32,34c-4.4,0-8-3.6-8-8s3.6-8,8-8   s8,3.6,8,8S36.4,34,32,34z"/>
                <path className="st0" d="M32,4C16.5,4,4,16.5,4,32c0,7.6,3.1,14.6,8,19.6c1.2,1.2,2.5,2.3,4,3.3c4.5,3.2,10,5,16,5s11.5-1.9,16-5   c1.4-1,2.7-2.1,4-3.3c5-5.1,8-12,8-19.6C60,16.5,47.5,4,32,4z M32,56c-6,0-11.4-2.2-15.6-5.8c1.1-3.6,4.4-6.2,8.3-6.2h14.7   c3.9,0,7.2,2.6,8.3,6.2C43.4,53.8,38,56,32,56z M50.7,47c-2.1-4.2-6.4-7-11.3-7H24.7c-5,0-9.3,2.9-11.3,7C10,42.9,8,37.7,8,32   C8,18.8,18.8,8,32,8s24,10.8,24,24C56,37.7,54,42.9,50.7,47z"/>
            </g>
        </svg>
    );
};

const ReplyIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <path d="M92.5,27.5H75v-15c0-1.4-1.1-2.5-2.5-2.5h-65C6.1,10,5,11.1,5,12.5v45C5,58.9,6.1,60,7.5,60h5v10c0,1.1,0.8,2.1,1.8,2.4  c0.2,0.1,0.4,0.1,0.7,0.1c0.9,0,1.7-0.4,2.1-1.2L23.9,60H25v15c0,1.4,1.1,2.5,2.5,2.5h48.6l6.8,11.3c0.5,0.8,1.3,1.2,2.1,1.2  c0.2,0,0.4,0,0.7-0.1c1.1-0.3,1.8-1.3,1.8-2.4v-10h5c1.4,0,2.5-1.1,2.5-2.5V30C95,28.6,93.9,27.5,92.5,27.5z M90,72.5h-5  c-1.4,0-2.5,1.1-2.5,2.5v3.5l-2.9-4.8c-0.5-0.8-1.3-1.2-2.1-1.2H30V60h42.5c1.4,0,2.5-1.1,2.5-2.5v-25h15V72.5z M20.4,56.2L17.5,61  v-3.5c0-1.4-1.1-2.5-2.5-2.5h-5V15h60v40H22.5C21.6,55,20.8,55.5,20.4,56.2z"/>
        </svg>
    );
};

const DecreaseFontSizeIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="5 5 30 30"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M25.5,8.5h-17v3h7v20h3v-20h7V8.5z M23.5,20.5v2h8v-2H23.5z"/>
    </svg>
    );
};

const IncreaseFontSizeIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="5 5 30 30"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <path fillRule="evenodd" clipRule="evenodd" d="M25.5,8.5h-17l0,3h7v20h3v-20h7L25.5,8.5z M28.5,18.5v-3h-2v3h-3v2h3v3h2v-3h3v-2H28.5z"/>
    </svg>
    );
};

const DecreasePageSpaceIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 70 50"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <path d="M106,1059 L91,1059 C89.8954305,1059 89,1058.10457 89,1057 L89,1043 C89,1041.89543 89.8954305,1041 91,1041 L106,1041 L106,1036 C106,1034.21819 108.154284,1033.32586 109.414214,1034.58579 L123.414214,1048.58579 C124.195262,1049.36684 124.195262,1050.63316 123.414214,1051.41421 L109.414214,1065.41421 C108.154284,1066.67414 106,1065.78181 106,1064 L106,1059 Z M93,1045 L93,1055 L108,1055 C109.104569,1055 110,1055.89543 110,1057 L110,1059.17157 L119.171573,1050 L110,1040.82843 L110,1043 C110,1044.10457 109.104569,1045 108,1045 L93,1045 Z M83,1055 C84.1045695,1055 85,1055.89543 85,1057 C85,1058.10457 84.1045695,1059 83,1059 L58,1059 C56.8954305,1059 56,1058.10457 56,1057 C56,1055.89543 56.8954305,1055 58,1055 L83,1055 Z M102,1069 C103.104569,1069 104,1069.89543 104,1071 C104,1072.10457 103.104569,1073 102,1073 L58,1073 C56.8954305,1073 56,1072.10457 56,1071 C56,1069.89543 56.8954305,1069 58,1069 L102,1069 Z M83,1041 C84.1045695,1041 85,1041.89543 85,1043 C85,1044.10457 84.1045695,1045 83,1045 L58,1045 C56.8954305,1045 56,1044.10457 56,1043 C56,1041.89543 56.8954305,1041 58,1041 L83,1041 Z M102,1027 C103.104569,1027 104,1027.89543 104,1029 C104,1030.10457 103.104569,1031 102,1031 L58,1031 C56.8954305,1031 56,1030.10457 56,1029 C56,1027.89543 56.8954305,1027 58,1027 L102,1027 Z" transform="translate(-56 -1027)"/>
        </svg>
    );
};

const IncreasePageSpaceIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 70 50"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <path d="M227,1059 L227,1064 C227,1065.78181 224.845716,1066.67414 223.585786,1065.41421 L209.585786,1051.41421 C208.804738,1050.63316 208.804738,1049.36684 209.585786,1048.58579 L223.585786,1034.58579 C224.845716,1033.32586 227,1034.21819 227,1036 L227,1041 L242,1041 C243.104569,1041 244,1041.89543 244,1043 L244,1057 C244,1058.10457 243.104569,1059 242,1059 L227,1059 Z M240,1045 L225,1045 C223.895431,1045 223,1044.10457 223,1043 L223,1040.82843 L213.828427,1050 L223,1059.17157 L223,1057 C223,1055.89543 223.895431,1055 225,1055 L240,1055 L240,1045 Z M205,1055 C206.104569,1055 207,1055.89543 207,1057 C207,1058.10457 206.104569,1059 205,1059 L178,1059 C176.895431,1059 176,1058.10457 176,1057 C176,1055.89543 176.895431,1055 178,1055 L205,1055 Z M222,1069 C223.104569,1069 224,1069.89543 224,1071 C224,1072.10457 223.104569,1073 222,1073 L178,1073 C176.895431,1073 176,1072.10457 176,1071 C176,1069.89543 176.895431,1069 178,1069 L222,1069 Z M205,1041 C206.104569,1041 207,1041.89543 207,1043 C207,1044.10457 206.104569,1045 205,1045 L178,1045 C176.895431,1045 176,1044.10457 176,1043 C176,1041.89543 176.895431,1041 178,1041 L205,1041 Z M222,1027 C223.104569,1027 224,1027.89543 224,1029 C224,1030.10457 223.104569,1031 222,1031 L178,1031 C176.895431,1031 176,1030.10457 176,1029 C176,1027.89543 176.895431,1027 178,1027 L222,1027 Z" transform="translate(-176 -1027)"/>
        </svg>
    );
};

const LeftArrowIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <polygon points="38.8,86.3 43.6,81.4 15.6,53.4 97.5,53.4 97.5,46.6 15.6,46.6 43.6,18.6 38.8,13.7 2.5,50"/>
    </svg>
    );
};

const RightArrowIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 100 100"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <polygon points="61.2,13.7 56.4,18.6 84.4,46.6 2.5,46.6 2.5,53.4 84.4,53.4 56.4,81.4 61.2,86.3 97.5,50"/>
    </svg>
    );
};

const SettingIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-5.0 -10.0 110.0 135.0"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <g>
            <path d="m50 72.398c-12.352 0-22.398-10.047-22.398-22.398s10.047-22.398 22.398-22.398 22.398 10.047 22.398 22.398-10.047 22.398-22.398 22.398zm0-38.547c-8.9023 0-16.148 7.2422-16.148 16.148s7.2461 16.148 16.148 16.148 16.148-7.2422 16.148-16.148-7.2461-16.148-16.148-16.148z"/>
            <path d="m55.211 96.875h-10.418c-1.4844 0-2.7656-1.0469-3.0625-2.5039l-2.1836-10.766c-2.043-0.63281-4.0195-1.4531-5.9141-2.4492l-9.1562 6.0703c-1.2383 0.82031-2.8828 0.65625-3.9375-0.39453l-7.3672-7.3672c-1.0508-1.0508-1.2148-2.6953-0.39453-3.9375l6.0703-9.1562c-0.99609-1.8906-1.8164-3.8711-2.4492-5.9141l-10.766-2.1836c-1.457-0.29688-2.5039-1.5781-2.5039-3.0625v-10.418c0-1.4844 1.0469-2.7656 2.5039-3.0625l10.766-2.1836c0.63281-2.043 1.4531-4.0234 2.4492-5.9141l-6.0703-9.1562c-0.82031-1.2383-0.65625-2.8867 0.39453-3.9375l7.3672-7.3672c1.0508-1.0508 2.6953-1.2188 3.9375-0.39453l9.1562 6.0703c1.8906-0.99609 3.8711-1.8164 5.9141-2.4492l2.1836-10.766c0.29688-1.457 1.5781-2.5039 3.0625-2.5039h10.418c1.4844 0 2.7656 1.0469 3.0625 2.5039l2.1836 10.766c2.043 0.63281 4.0234 1.4531 5.9141 2.4492l9.1562-6.0703c1.2383-0.82031 2.8867-0.65625 3.9375 0.39453l7.3672 7.3672c1.0508 1.0508 1.2148 2.6953 0.39453 3.9375l-6.0703 9.1562c0.99609 1.8906 1.8164 3.8711 2.4492 5.9141l10.766 2.1836c1.457 0.29688 2.5039 1.5781 2.5039 3.0625v10.418c0 1.4844-1.0469 2.7656-2.5039 3.0625l-10.766 2.1836c-0.63281 2.043-1.4531 4.0234-2.4492 5.9141l6.0703 9.1562c0.82031 1.2383 0.65625 2.8867-0.39453 3.9375l-7.3672 7.3672c-1.0508 1.0508-2.6992 1.2188-3.9375 0.39453l-9.1562-6.0703c-1.8906 0.99609-3.8711 1.8164-5.9141 2.4492l-2.1836 10.766c-0.29688 1.457-1.5781 2.5039-3.0625 2.5039zm-7.8672-6.25h5.3086l2.0547-10.133c0.23828-1.1797 1.1367-2.1172 2.3086-2.4102 2.7734-0.69141 5.4258-1.7891 7.875-3.2617 1.0312-0.62109 2.332-0.59375 3.3359 0.074219l8.6211 5.7148 3.7539-3.7539-5.7148-8.6211c-0.66797-1.0078-0.69531-2.3047-0.074219-3.3359 1.4727-2.4492 2.5703-5.0977 3.2656-7.875 0.29297-1.1719 1.2305-2.0664 2.4102-2.3086l10.133-2.0547v-5.3047l-10.133-2.0547c-1.1797-0.23828-2.1172-1.1367-2.4102-2.3086-0.69141-2.7773-1.7891-5.4258-3.2656-7.875-0.62109-1.0312-0.59375-2.332 0.074219-3.3359l5.7148-8.6211-3.7539-3.7539-8.6211 5.7148c-1.0039 0.66797-2.3047 0.69531-3.3359 0.074218-2.4453-1.4727-5.0977-2.5703-7.875-3.2617-1.1719-0.29297-2.0664-1.2305-2.3086-2.4102l-2.0547-10.133h-5.3086l-2.0547 10.133c-0.23828 1.1797-1.1367 2.1172-2.3086 2.4102-2.7734 0.69141-5.4258 1.7891-7.875 3.2617-1.0312 0.62109-2.332 0.59375-3.3359-0.074218l-8.6211-5.7148-3.7539 3.7539 5.7148 8.6211c0.66797 1.0078 0.69531 2.3047 0.074219 3.3359-1.4727 2.4492-2.5703 5.0977-3.2656 7.875-0.29297 1.1719-1.2305 2.0664-2.4102 2.3086l-10.133 2.0547v5.3047l10.133 2.0547c1.1797 0.23828 2.1172 1.1367 2.4102 2.3086 0.69141 2.7773 1.7891 5.4258 3.2656 7.875 0.62109 1.0312 0.59375 2.332-0.074219 3.3359l-5.7148 8.6211 3.7539 3.7539 8.6211-5.7148c1.0039-0.66797 2.3047-0.69531 3.3359-0.074219 2.4492 1.4727 5.1016 2.5703 7.875 3.2617 1.1719 0.29297 2.0664 1.2305 2.3086 2.4102zm46.406-35.418h0.015625z"/>
        </g>
    </svg>
    );
};

const ListIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-5.0 -10.0 110.0 135.0"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <g>
            <path d="m83.359 25.922h-66.82c-1.1016 0-2-0.89844-2-2s0.89844-2 2-2h66.82c1.1016 0 2 0.89844 2 2s-0.89844 2-2 2z"/>
            <path d="m83.461 51.949h-66.82c-1.1016 0-2-0.89844-2-2 0-1.1016 0.89844-2 2-2h66.82c1.1016 0 2 0.89844 2 2 0 1.1016-0.89844 2-2 2z"/>
            <path d="m83.461 78.078h-66.82c-1.1016 0-2-0.89844-2-2s0.89844-2 2-2h66.82c1.1016 0 2 0.89844 2 2s-0.89844 2-2 2z"/>
        </g>
    </svg>
    );
};

const BookIcon = ({ size = 16, color }) => {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="-5.0 -10.0 110.0 135.0"
        fill="currentColor"
        className={`${color}`}
        style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
    >
        <path d="m77.777 3.7031h-55.555c-2.4492 0-4.7734 0.96094-6.5586 2.7188-1.7422 1.7656-2.6992 4.0898-2.6992 6.5391v74.074c0 5.1055 4.1523 9.2578 9.2578 9.2578h59.258c3.0625 0 5.5547-2.4922 5.5547-5.5547v-66.664c0-2.4141-1.5469-4.4727-3.7031-5.2383v-9.5742c0-3.0625-2.4922-5.5547-5.5547-5.5547zm-59.496 5.3359c1.0703-1.0547 2.4688-1.6328 3.9414-1.6328h55.555c1.0234 0 1.8516 0.83203 1.8516 1.8516v9.2578l-57.406 0.003906c-3.0625 0-5.5547-2.4922-5.5547-5.5547 0-1.4727 0.57812-2.8711 1.6133-3.9219zm-1.6133 77.996v-66.715c1.5508 1.1758 3.4648 1.8984 5.5547 1.8984h1.8516v70.371h-1.8516c-3.0625 0-5.5547-2.4922-5.5547-5.5547zm66.668 3.7031c0 1.0234-0.82813 1.8516-1.8516 1.8516l-53.707 0.003906v-70.371h53.703c1.0234 0 1.8516 0.83203 1.8516 1.8516v66.668zm-59.262-77.773c0-1.0234 0.82812-1.8516 1.8516-1.8516h48.148c1.0234 0 1.8516 0.82812 1.8516 1.8516 0 1.0234-0.82812 1.8516-1.8516 1.8516h-48.148c-1.0234 0-1.8516-0.82812-1.8516-1.8516zm50 16.668h-37.035c-1.0234 0-1.8516 0.82813-1.8516 1.8516v22.223c0 1.0234 0.82812 1.8516 1.8516 1.8516h37.035c1.0234 0 1.8516-0.82812 1.8516-1.8516v-22.223c0-1.0234-0.82812-1.8516-1.8516-1.8516zm-1.8516 22.223h-33.332v-18.52h33.332z"/>
    </svg>
    );
};

const NotificationIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 100 100"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <g fillRule="evenodd">
                <path d="m60.824 82.812c-0.75781 5.2969-5.3164 9.375-10.824 9.375s-10.066-4.0781-10.828-9.375z" />
                <path d="m50 7.8125c-2.5898 0-4.6875 2.0977-4.6875 4.6875v0.78906c0 0.71094-0.48438 1.3359-1.1719 1.5117-10.109 2.6016-17.578 11.777-17.578 22.699v14.645c0 6.2148-2.4688 12.176-6.8633 16.574l-5.1797 5.1758c-0.29297 0.29297-0.45703 0.69141-0.45703 1.1055v3.125c0 0.86328 0.69922 1.5625 1.5625 1.5625h68.75c0.86328 0 1.5625-0.69922 1.5625-1.5625v-3.125c0-0.41406-0.16406-0.8125-0.45703-1.1055l-5.1797-5.1758c-4.3945-4.3984-6.8633-10.359-6.8633-16.574v-14.645c0-10.922-7.4688-20.098-17.578-22.699-0.6875-0.17578-1.1719-0.80078-1.1719-1.5117v-0.78906c0-2.5898-2.0977-4.6875-4.6875-4.6875z" />
                <path d="m28.461 12.926c-6.9453 6.5547-11.273 15.84-11.273 26.137 0 0.86328 0.69922 1.5625 1.5625 1.5625s1.5625-0.69922 1.5625-1.5625c0-9.4023 3.9531-17.879 10.293-23.863 0.625-0.59375 0.65234-1.582 0.0625-2.2109-0.58984-0.625-1.582-0.65234-2.207-0.0625z" />
                <path d="m82.812 39.062c0-10.297-4.3281-19.582-11.273-26.137-0.625-0.58984-1.6172-0.5625-2.207 0.0625-0.58984 0.62891-0.5625 1.6172 0.0625 2.2109 6.3398 5.9844 10.293 14.461 10.293 23.863 0 0.86328 0.69922 1.5625 1.5625 1.5625s1.5625-0.69922 1.5625-1.5625z" />
            </g>
        </svg>
    );
};

const ClockIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 90 90"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <g>
                <path d="m50 86.5c20.102 0 36.5-16.398 36.5-36.5s-16.398-36.5-36.5-36.5-36.5 16.398-36.5 36.5 16.398 36.5 36.5 36.5zm0-70c18.5 0 33.5 15 33.5 33.5s-15 33.5-33.5 33.5-33.5-15-33.5-33.5 15-33.5 33.5-33.5z" />
                <path d="m50 28c0.80078 0 1.5-0.69922 1.5-1.5v-5.8984c0-0.80078-0.69922-1.5-1.5-1.5s-1.5 0.69922-1.5 1.5v5.8984c0 0.80078 0.69922 1.5 1.5 1.5z" />
                <path d="m28 50c0-0.80078-0.69922-1.5-1.5-1.5h-5.8984c-0.80078 0-1.5 0.69922-1.5 1.5s0.69922 1.5 1.5 1.5h5.8984c0.80078 0 1.5-0.69922 1.5-1.5z" />
                <path d="m50 80.898c0.80078 0 1.5-0.69922 1.5-1.5v-5.8984c0-0.80078-0.69922-1.5-1.5-1.5s-1.5 0.69922-1.5 1.5v5.8984c0 0.80078 0.69922 1.5 1.5 1.5z" />
                <path d="m73.5 51.5h5.8984c0.80078 0 1.5-0.69922 1.5-1.5s-0.69922-1.5-1.5-1.5h-5.8984c-0.80078 0-1.5 0.69922-1.5 1.5s0.69922 1.5 1.5 1.5z" />
                <path d="m61.699 62.199c0.30078 0.19922 0.60156 0.39844 1 0.39844 0.39844 0 0.80078-0.19922 1.1016-0.5 0.5-0.60156 0.5-1.6016-0.10156-2.1016l-12.199-10.695 0.10156-11.801c0-0.80078-0.69922-1.5-1.5-1.5-0.80078 0-1.5 0.69922-1.5 1.5l-0.10156 12.5c0 0.39844 0.19922 0.89844 0.5 1.1016z" />
            </g>
        </svg>
    );
};

const FlagIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 80 100"
            fill="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <path d="m30.699 19.199v-7c0-1.1992-1-2.1992-2.1992-2.1992s-2.1992 1-2.1992 2.1992v75.699c0 1.1992 1 2.1992 2.1992 2.1992s2.1992-1 2.1992-2.1992v-42.398c14.301 5.5 28.602-8.5 42.902-0.89844v-26.301c-14.301-7.6016-28.602 6.3008-42.902 0.89844z" />
        </svg>
    );
};

const LikeIcon = ({ size = 16, color }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            className={`${color}`}
            style={{ width: `${size * 2}px`, height: `${size * 2}px` }}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
            />
        </svg>
    );
};

export {
    CommentIcon,
    DeleteIcon,
    EditIcon,
    ExpandIcon,
    ProfileIcon,
    ReplyIcon,
    DecreaseFontSizeIcon,
    IncreaseFontSizeIcon,
    DecreasePageSpaceIcon,
    IncreasePageSpaceIcon,
    LeftArrowIcon,
    RightArrowIcon,
    SettingIcon,
    ListIcon,
    BookIcon,
    NotificationIcon,
    ClockIcon,
    FlagIcon,
    LikeIcon
};